import { PaginationSidesContainer } from '../styled-components.js'

export const PaginationLeft = ({ totalElements, pageNumber, pageSize }) => {
  const hasElements = totalElements > 0
  const firstElement = hasElements ? pageNumber * pageSize + 1 : 0
  const lastElement = hasElements
    ? Math.min(firstElement + pageSize - 1, totalElements)
    : 0

  return (
    <PaginationSidesContainer>
      <span>
        <span>{firstElement}</span>
        <span>-</span>
        <span>{lastElement}</span>
      </span>
      <span>of</span>
      <span>{totalElements}</span>
    </PaginationSidesContainer>
  )
}

export default PaginationLeft
